import styled from "@emotion/styled";
import colors from "../../styles/colors";
export const FlexContainer = styled.div `
  display: flex;
  flex-direction: ${(props) => (props.showAsColumn ? "column" : "row")};
  gap: 1rem;
`;
export const SelectorButtonContainer = styled.div `
  display: flex;
  width: fit-content;
  min-width: 100px;
  flex-direction: row;
  gap: 0.5rem;
  align-items: center;
  padding: 12px 20px 12px 16px;
  border-radius: 32px;
  border: 1px solid ${colors["color-gray-40"]};
  background: ${(props) => props.disabled ? colors["color-gray-40"] : colors["color-white-100"]};
  box-shadow: ${(props) => props.disabled
    ? "none"
    : "0px 2px 4px -2px rgba(0, 0, 0, 0.1), 0px 4px 6px -1px rgba(0, 0, 0, 0.1)"};
  &:focus-visible {
    box-shadow: 0px 0px 0px 4px ${colors["color-blue-70"]};
    border-color: ${colors["color-blue-160"]};
    background-color: ${colors["color-blue-50"]};
  }
  &:focus-visible span {
    color: ${colors["color-blue-160"]};
  }
  &:focus-visible svg {
    fill: ${colors["color-blue-160"]};
  }
`;
export const SelectorButtonIcon = styled.input `
  display: flex;
`;
export const SelectorButtonText = styled.span `
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  color: ${(props) => props.disabled ? colors["color-gray-110"] : colors["color-gray-140"]};
  line-height: 20px;
`;
//# sourceMappingURL=SelectorButton.styled.js.map